import { LazyLoadEvent } from 'primeng/api';
import { ArquivoConciliacaoBancaria } from './../../../base/domain/arquivo-conciliacao-bancaria.model';
import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { QueryOptions } from '../../domain/query.options';
import { Page } from 'src/app/base/domain/return-api.model';

export interface ConciliacaoBancariaFilterOptions {
  dataInicial: Date;
  dataFinal: Date;
}

export interface ConciliacaoBancariaEvent {
  acao: string;
  arquivo: ArquivoConciliacaoBancaria;
}

@Component({
  selector: 'app-arquivo-conciliacao-list',
  templateUrl: './arquivo-conciliacao-list.component.html',
  styleUrls: ['./arquivo-conciliacao-list.component.css'],
})
export class ArquivoConciliacaoListComponent implements OnInit {
  @Output() filter = new EventEmitter<ConciliacaoBancariaFilterOptions>();
  @Output() loadArquivosPage = new EventEmitter<number>();
  @Output() acaoClick = new EventEmitter<ConciliacaoBancariaEvent>();
  @Output() menuAcaoClick = new EventEmitter<string>();

  public static IMPORTAR_ARQUIVO = 'Importar Arquivo';
  menuAcoes: string[] = ['Importar Arquivo'];

  filterOptions: ConciliacaoBancariaFilterOptions;
  private readonly defaultFilterOptions: ConciliacaoBancariaFilterOptions = {
    dataInicial: null,
    dataFinal: null,
  };

  @Input() page: Page<ArquivoConciliacaoBancaria>;
  @Input() totalRecords: number;
  @Input() rowsNumber: number;
  @Input() loading: boolean;

  private currentPage = 0;
  queryOptions = new QueryOptions();

  constructor() {
    this.onLimparFiltros();
  }

  ngOnInit(): void {}

  loadArquivos(event: LazyLoadEvent): void {
    const pageNumber = Math.floor(event.first / event.rows);
    this.currentPage = pageNumber;
    this.loadArquivosPage.emit(pageNumber);
  }

  onAtualizar(): void {
    this.loadArquivosPage.emit(this.currentPage);
  }

  onMenuAcaoClick(event: string): void {
    this.menuAcaoClick.emit(event);
  }

  onAcaoClick(acao: string, domain: ArquivoConciliacaoBancaria): void {
    this.acaoClick.emit({ acao, arquivo: domain });
  }

  onLimparFiltros(): void {
    this.filterOptions = Object.assign({}, this.defaultFilterOptions);
  }

  onAplicarFiltro(): void {
    this.filter.emit(this.filterOptions);
  }
}
